import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { appRedirectGuard } from './app-redirect.guard';
import { AccessDeniedComponent } from './shared/access-denied/access-denied.component';
import { WalletBindingComponent } from './pages/wallet-binding/wallet-binding.component';
import { WalletBindingCallbackComponent } from './pages/wallet-binding-callback/wallet-binding-callback.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [appRedirectGuard],
    data: {
      title: 'Virtual Card',
    },
    loadChildren: () =>
      import('./pages/wallet-account-otp/wallet-account-otp.module').then(
        (m) => m.WalletAccountOtpModule
      ),
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: 'binding/:id',
    component: WalletBindingComponent,
  },
  {
    path: 'binding-callback/:id',
    component: WalletBindingCallbackComponent,
  },
  {
    path: '**',
    component: AccessDeniedComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
